const prices = [
  //columns
  {
    name: "staander_150x150",
    label: "Staander",
    unit: "m",
    price: 100.0,
  },
  {
    name: "standdeer_110x110",
    label: "Staander",
    unit: "m",
    price: 100.0,
  },

  //rooftop materials | Glass Material
  {
    name: "glasslight",
    label: "Glasplaat dak",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "glassdark",
    label: "Glasplaat dak donker",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "polylight",
    label: "Polycarbonaat Opaal",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "polymid",
    label: "Polycarbonaat Helder",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "polydark",
    label: "Polycarbonaat Zonwerend",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "polywide",
    label: "Polycarbonaat Breed",
    unit: "m²",
    price: 100.0,
  },
  // {
  //   name: "oaseglass",
  //   label: "Glasplaat dak",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "oaseglassdark",
  //   label: "Glasplaat dak donker",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "oasepolylight",
  //   label: "Polycarbonaat Opaal",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "oasepolymid",
  //   label: "Polycarbonaat Helder",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "oasepolydark",
  //   label: "Polycarbonaat Zonwerend",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "oasepolywide",
  //   label: "Polycarbonaat Breed",
  //   unit: "m",
  //   price: 100.0,
  // },

  //Aludra
  {
    name: "goot",
    label: "Gootprofiel",
    unit: "m",
    price: 100.0,
  },
  {
    name: "ligger_165x200",
    label: "Ligger 165x200",
    unit: "m",
    price: 100.0,
  },
  {
    name: "ligger",
    label: "Ligger",
    unit: "m",
    price: 100.0,
  },
  {
    name: "middenAfdekker",
    label: "Middenafdekker",
    unit: "m",
    price: 100.0,
  },
  {
    name: "plaatstopper",
    label: "Plaatstopper",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "muurplaat",
    label: "Muurprofiel",
    unit: "m",
    price: 100.0,
  },

  {
    name: "condensprofiel",
    label: "Condensprofiel",
    unit: "cm",
    price: 5.0,
  },

  //Oase
  {
    name: "gootprofiel",
    label: "Gootprofiel",
    unit: "m",
    price: 100.0,
  },
  {
    name: "afdekkapGootprofiel",
    label: "Afdekkap gootprofiel",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "liggerOase",
    label: "Ligger",
    unit: "m",
    price: 100.0,
  },
  {
    name: "zijAfdekker",
    label: "Zijafdekker",
    unit: "m",
    price: 100.0,
  },
  {
    name: "middenAfdekkerOase",
    label: "Middenafdekker",
    unit: "m",
    price: 100.0,
  },
  {
    name: "muurplaatOase",
    label: "Muurprofiel",
    unit: "m",
    price: 100.0,
  },
  {
    name: "afdekkapmuurprofiel",
    label: "Afdekkapmuurprofiel",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "gootsierlijstKlassiek",
    label: "Gootsierlijst Klassiek",
    unit: "m",
    price: 100.0,
  },
  {
    name: "gootcapKlassiek",
    label: "gootcapKlassiek",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "gootsierlijstRond",
    label: "Gootsierlijst Rond",
    unit: "m",
    price: 100.0,
  },
  {
    name: "gootcapRond",
    label: "gootcapRond",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "condensprofielOase",
    label: "Condensprofiel",
    unit: "cm",
    price: 5.0,
  },
  {
    name: "oaseplaatstopper",
    label: "Plaatstopper",
    unit: "stuk",
    price: 100.0,
  },

  //Spy
  {
    name: "spyFrame",
    // label: "Spie Frame",
    label: "Spie Frame",
    unit: "m",
    price: 100.0,
  },
  {
    name: "polycarbonatSpy",
    label: "Spie Polycarbonat",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "polycarbonatWideSpy",
    label: "Spie Polycarbonaat Breed",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "glassSpy",
    label: "Spie Glas",
    unit: "m²",
    price: 100.0,
  },

  //sunscreen
  {
    name: "sunScreenBody",
    label: "Zonwering Body",
    unit: "m",
    price: 100.0,
  },
  {
    name: "sunScreenSideGuide",
    label: "Zonwering SideGuide",
    unit: "m",
    price: 100.0,
  },
  {
    name: "sunScreenGuideMountingBracketsBottom",
    label: "Zonwering Brackets",
    unit: "m",
    price: 100.0,
  },
  {
    name: "sunScreenGuideMountingBracketsTop",
    label: "Zonwering Brackets",
    unit: "m",
    price: 100.0,
  },
  {
    name: "sunScreenGuideMountingBracketsTopOase",
    label: "Zonwering Brackets",
    unit: "m",
    price: 100.0,
  },
  {
    name: "sunScreenTextile",
    label: "Zonwering Textile",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "sunScreenMolding",
    label: "Zonwering Molding",
    unit: "m",
    price: 100.0,
  },
  {
    name: "spotlight",
    label: "Verlichting",
    unit: "stuk",
    price: 8.0,
  },

  //services
  {
    name: "unevenwidth",
    label: "Maatwerk breedte",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "unevendepth",
    label: "Maatwerk diepte",
    unit: "stuk",
    price: 100.0,
  },

  //walls
  // {
  //   name: "window_2x2Tracks",
  //   label: "window_2x2Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "window_4x4Tracks",
  //   label: "window_4x4Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_3x3Tracks",
  //   label: "door_3x3Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_4x4Tracks",
  //   label: "door_4x4Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_4x2Tracks",
  //   label: "door_4x2Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_5x3Tracks",
  //   label: "door_5x3Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_5x5Tracks",
  //   label: "door_5x5Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_6x3_Tracks",
  //   label: "door_6x3_Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_6x6_Tracks",
  //   label: "door_6x6_Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_7x4_Tracks",
  //   label: "door_7x4_Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  // {
  //   name: "door_7x7_Tracks",
  //   label: "door_7x7_Tracks",
  //   unit: "m",
  //   price: 100.0,
  // },
  {
    name: "aluminiumWall",
    label: "Aluminium Zijwand",
    unit: "m²",
    price: 100.0,
  },
  {
    name: "glassdoors",
    label: "Glazen schuifwand",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "glassdoorsdark",
    label: "Glazen schuifwand donker",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "windowdoors",
    label: "Steellook schuifwand",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "windowdoorsdark",
    label: "Steellook schuifwand donker",
    unit: "stuk",
    price: 100.0,
  },

  //poer
  {
    name: "poer",
    label: "Poer",
    unit: "stuk",
    price: 100.0,
  },
  {
    name: "hwapoer",
    label: "HWA Poer",
    unit: "stuk",
    price: 90.0,
  },
  {
    name: "fundering",
    label: "Fundatiekoker",
    unit: "m",
    price: 95.0,
  },

  //addons
  {
    name: "kliklijst",
    label: "Kliklijst",
    unit: "stuk",
    price: 100.0,
  },
];

export default prices;
